import React, { createContext, useCallback, useEffect, useState } from 'react'
import Terms from './Terms'
import { useAppDispatch, useAppSelector } from '../../store/utils/hooks'
import { actionEditUserData, selectUserData } from '../../store/slices/user/userSlice'

type TermsProviderProps = {
	children: React.ReactNode
}

const TermsContext = createContext(null)

export default function TermsProvider({ children }: TermsProviderProps) {
	const dispatch = useAppDispatch()
	const { data: userData } = useAppSelector(selectUserData)
	const [showTos, setShowTos] = useState<boolean>(false)

	const acceptTOS = useCallback(async () => {
		dispatch(actionEditUserData({ user_id: userData.user_id, has_accepted_terms_of_service: true }))
		setShowTos(false)
	}, [dispatch, userData.user_id])

	useEffect(() => {
		if (!userData.has_accepted_terms_of_service) {
			setShowTos(!userData.has_accepted_terms_of_service)
		}
	}, [userData])

	return (
		<TermsContext.Provider value={null}>
			{children}
			<Terms show={showTos} accept={acceptTOS} />
		</TermsContext.Provider>
	)
}
